import {Injectable} from '@angular/core';
import {
  EvaluationSubCriteriaAttributeView,
  EvaluationSubCriteriaImportanceScore,
  UpsertEvaluationSubCriteriaAttributeRequest,
} from '@frontend/shared-api';

export interface SubcriteriaAttributeForSave {
  id?: number;
  directusId: string;
  scaNumber: number;
  selectedImportanceScore?: EvaluationSubCriteriaImportanceScore;
  hasChanges?: boolean;
  isSaving?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SubcriteriaAttributeSaveService {
  buildSaveRequest(
    changedItems: SubcriteriaAttributeForSave[],
  ): UpsertEvaluationSubCriteriaAttributeRequest {
    const attributes = changedItems.map((item) => ({
      ...(item.id && {id: item.id}),
      importanceScore: item.selectedImportanceScore,
      directusId: item.directusId,
      scaNumber: item.scaNumber,
    }));

    return {
      attributes,
    };
  }

  processSaveResponses<T extends SubcriteriaAttributeForSave>(
    items: T[],
    responses: EvaluationSubCriteriaAttributeView[],
  ): T[] {
    return items.map((item) => {
      const response = responses.find((r) => r.directusId === item.directusId);
      return {
        ...item,
        id: response?.id || item.id,
        hasChanges: false,
        isSaving: false,
      };
    });
  }
}
